import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_switch = _resolveComponent("el-switch");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, {
        label: _ctx.label,
        description: _ctx.description,
        required: _ctx.required
    }, {
        default: _withCtx(() => [
            _createVNode(_component_el_switch, {
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                "inline-prompt": "",
                "active-icon": _ctx.Check,
                "inactive-icon": _ctx.Close,
                onChange: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('change', $event)))
            }, null, 8 /* PROPS */, ["modelValue", "active-icon", "inactive-icon"])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["label", "description", "required"]));
}
